import { render, staticRenderFns } from "./AperturaSubsede.vue?vue&type=template&id=1654026e&"
import script from "./AperturaSubsede.vue?vue&type=script&lang=js&"
export * from "./AperturaSubsede.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports